export const common = {
  actions: {
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    close: 'Закрыть',
    edit: 'Редактировать',
    create: 'Создать',
    add: 'Добавить',
    apply: 'Применить',
    reset: 'Сбросить',
    retry: 'Повторить',
    search: 'Поиск',
    confirm: 'Подтвердить',
    copy: 'Скопировать',
    back: 'Назад',
    toHome: 'На главную'
  },
  states: {
    loading: 'Загрузка…',
    saving: 'Сохранение…',
    noData: 'Нет данных',
    copied: 'Скопировано',
    error: 'Ошибка'
  },
  yes: 'Да',
  no: 'Нет',
  all: 'Все',
  sidebar: {
    profileTitle: 'Личный кабинет',
    online: 'Онлайн',
    onlineUsers: (authenticated: number, guests: number) => `Онлайн: авторизованы ${authenticated}, гости ${guests}`,
    loginWithSteam: 'Войти через Steam',
    loginConsentPrefix: 'Входя, вы соглашаетесь с',
    loginConsentLink: 'Политикой обработки персональных данных',
    mainNavigation: 'Основная навигация',
    logout: 'Выйти',
    privacyPolicy: 'Политика обработки персональных данных',
    languageSwitcher: 'Язык интерфейса',
    adminMenu: 'Меню администратора',
    openMenu: 'Открыть меню',
    closeMenu: 'Закрыть меню',
    profile: 'Профиль',
    profileMenu: 'Меню профиля',
    siteNavigation: 'Навигация по сайту'
  }
};
